import { render, staticRenderFns } from "./proposal-progress.vue?vue&type=template&id=3d80e8ca"
import script from "./proposal-progress.vue?vue&type=script&lang=ts"
export * from "./proposal-progress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports